module.exports = __webpack_public_path__ + "assets/img/marketing_vector.ee50e240.svg";